import {
  Firestore,
  collection,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";

export const normalizeUsernameBase = (rawValue: string) => {
  const normalized = rawValue
    .toLowerCase()
    .replace(/[^a-z0-9_.]/g, "")
    .replace(/^[^a-z0-9]+/, "")
    .slice(0, 20);

  return normalized || `user${Date.now().toString().slice(-6)}`;
};

export const getUniqueUsername = async (
  firestore: Firestore,
  rawBase: string,
) => {
  const base = normalizeUsernameBase(rawBase);

  for (let suffix = 0; suffix < 100; suffix += 1) {
    const suffixText = suffix === 0 ? "" : `_${suffix}`;
    const maxBaseLength = Math.max(1, 20 - suffixText.length);
    const candidate = `${base.slice(0, maxBaseLength)}${suffixText}`;

    const isAvailable = await isUsernameAvailable(firestore, candidate);
    if (isAvailable) {
      return candidate;
    }
  }

  const fallback = `${base.slice(0, 12)}_${Date.now().toString().slice(-6)}`;
  return fallback.slice(0, 20);
};

export const isUsernameAvailable = async (
  firestore: Firestore,
  candidateUsername: string,
  currentUserId?: string,
) => {
  const usernameQuery = query(
    collection(firestore, "users"),
    where("username", "==", candidateUsername),
    limit(5),
  );
  const usernameSnapshot = await getDocs(usernameQuery);

  if (!currentUserId) {
    return usernameSnapshot.empty;
  }

  return !usernameSnapshot.docs.some((userDoc) => userDoc.id !== currentUserId);
};
